<template>
  <div class=wrapper>
    <div id=player class=player ref=player></div>
  </div>
</template>

<script>
import { db } from '@/config'
import { mapActions, mapGetters } from 'vuex'
// import bitmovinAnalytics from 'bitmovin-analytics';
// import { Player, PlayerEvent } from 'bitmovin-player';
// import * as playerui from 'bitmovin-player-ui';
const playerKey = '99d282f8-9e7a-4bbb-bd1c-5e4ae5aaef0a'
const analyticsKey = '7ceb7c06-ebd7-4ea8-b9da-c5d691831e62'
// const bitmovin = window.bitmovin
// import * as bitmovin from 'bitmovin-player'
// import { Player, PlayerEvent } from 'bitmovin-player/modules/bitmovinplayer-core';
// import BitmovinEngineModule from 'bitmovin-player/modules/bitmovinplayer-engine-bitmovin';
// import MSERendererModule from 'bitmovin-player/modules/bitmovinplayer-mserenderer';
// // import HLSModule from 'bitmovin-player/modules/bitmovinplayer-hls';
// // import ABRModule from 'bitmovin-player/modules/bitmovinplayer-abr';
// // import TSContainerModule from 'bitmovin-player/modules/bitmovinplayer-container-ts';
// import BitmovinPlayerDrm from 'bitmovin-player/modules/bitmovinplayer-drm'
// import BitmovinPlayerDash from 'bitmovin-player/modules/bitmovinplayer-dash'

// import BitmovinPlayerSubtitles from 'bitmovin-player/modules/bitmovinplayer-subtitles'
// import BitmovinPlayerSubtitlesCea608 from 'bitmovin-player/modules/bitmovinplayer-subtitles-cea608'
// import BitmovinPlayerSubtitlesTtml from 'bitmovin-player/modules/bitmovinplayer-subtitles-ttml'
// import BitmovinPlayerSubtitlesNative from 'bitmovin-player/modules/bitmovinplayer-subtitles-native'
// // import BitmovinPlayerUserSettings from 'bitmovin-player/modules/bitmovinplayer-user-settings'

// Player.addModule(BitmovinEngineModule)
// Player.addModule(MSERendererModule)
// // Player.addModule(HLSModule)
// // Player.addModule(ABRModule)
// // Player.addModule(TSContainerModule)
// Player.addModule(BitmovinPlayerDrm)
// Player.addModule(BitmovinPlayerDash)

// Player.addModule(BitmovinPlayerSubtitles)
// Player.addModule(BitmovinPlayerSubtitlesCea608)
// Player.addModule(BitmovinPlayerSubtitlesTtml)
// Player.addModule(BitmovinPlayerSubtitlesNative)
// // Player.addModule(BitmovinPlayerUserSettings)

export default {
  name: 'Video',
  data () {
    return {
      fromTimestamp: false,
      player: null,
      session: null,
      sessionRef: null,
      modalData: null,
      setupInit: null,
      pid: null
    }
  },
  computed: {
    ...mapGetters(['program'])
  },
  async created () {
    this.fromTimestamp = this.$route.query.timestamp
    await this.getProgram(this.$route.params.id)
    if (!this.modalData) {
      this.modalData = this.program
      this.modalData && this.setup()
    }
  },
  mounted () {
    this.modalData = this.modalData || this.program
    this.modalData && this.setup()
  },
  methods: {
    ...mapActions(['getProgram']),
    setup () {
      if (this.setupInit) return;
      this.setupInit = true
      this.modalData = this.modalData || this.program
      var user = this.$store.getters.user
      if (user == null) {
        this.$bvueUi.modal.close()
        console.log('ERROR: trying to see video unregistered user')
        return
      }

      this.modalData.video.dash = this.modalData.video.dash
      this.modalData.video.hls = this.modalData.video.hls

      const config = {
        key: playerKey,
        // ui: false,
        // analytics: {
        //   key: analyticsKey,
        //   videoId: this.modalData.slug,
        //   title: this.modalData.video.master_file_name || 'filename',
        //   customData1: user.uid, // User id
        //   customData2: this.modalData.id, // Program id
        //   customData3: this.modalData.slug, // Program slug
        //   customData4: this.modalData.video.master_file_name || 'filename' // Filename
        // },
        source: {
          dash: this.modalData.video.dash,
          hls: this.modalData.video.hls,
          poster: this.modalData.video.poster,
          drm: {
            widevine: {
              LA_URL: 'https://widevine-dash.ezdrm.com/proxy?pX=80BA2D'
            },
            playready: {
              LA_URL: 'https://playready.ezdrm.com/cency/preauth.aspx?pX=A8DC04'
            },
            fairplay: {
              LA_URL: 'https://fps.ezdrm.com/api/licenses/93642bc7-2e2e-446d-9f9f-c3e84d29df07',
              certificateURL: 'https://www.bvapps.es/fairplaySafari.cer',
              prepareContentId: function(contentId) {
                var uri = contentId;
                var uriParts = uri.split('://', 1);
                var protocol = uriParts[0].slice(-3);
                uriParts = uri.split(';', 2);
                contentId = uriParts.length > 1 ? uriParts[1] : '';
                uriParts = contentId.split('?', 2);
                contentId = uriParts.length > 1 ? uriParts[0] : contentId;
                return protocol.toLowerCase() == 'skd' ? contentId : '';
              },
              prepareLicenseAsync: function(ckc) {
                console.log({ckc})
                return new Promise(function(resolve, reject) {
                  const reader = new FileReader();
                  reader.addEventListener('loadend', function() {
                    resolve(new Uint8Array(reader.result));
                  });
                  reader.addEventListener('error', function() {
                    reject(reader.error);
                  });
                  reader.readAsArrayBuffer(ckc);
                });
              },
              prepareMessage: function(event, session) {
                console.log({event, session})
                return new Blob([event.message], {type: 'application/octet-binary'});
              },
              headers: [{
                name: 'content-type',
                value: 'application/octet-stream'
              }],
              useUint16InitData: true,
              licenseResponseType: 'blob'
            }
          }
        }
      }

      this.modalData.video = {...this.modalData.video, ...config.source}
      console.log(config)

      // var container = document.getElementById('player')
      // this.player = bitmovin(this.$refs.player, config)
      // console.log(this.player, bitmovin.PlayerEvent, bitmovin)
      // console.log('this.player...', this.player, bitmovin)

      // this.player = bitmovin.player('player')
      // bitmovin.analytics.augment(player)

      // player.setup(config).then(
      //   function(value) {
      //     console.log('Successfully created bitmovin player instance');
      //   },
      //   function(reason) {
      //     console.log('Error while creating bitmovin player instance');
      //   }
      // )


      this.player = new bitmovin.player.Player(this.$refs.player, { key: config.key, ui: false })
      // this.player.load(this.modalData.video).then(() => {
      // this.playerUi = UIFactory.buildDefaultUI(this.player);
      this.player.load(config.source).then(() => {
        const currentUiManager = bitmovin.playerui.UIFactory.buildDefaultUI(this.player);
        console.log('player ready')
        var session = {
          program_slug: this.modalData.slug,
          user_id: user.uid,
          date: new Date().getTime(),
          duration: 0,
          device_id: this.$store.state.deviceId,
          ip: this.$store.state.ip,
          prefered_language_audio: 'es',
          prefered_language_subtitulos: 'es'
        }
        this.session = session
        var ref = db.collection('log_video_views').doc()
        this.sessionRef = ref
        ref.set(this.session)
        this.player.play()
      })
      .catch(error => {
        console.error(error)
      })


      // EVENTS
      this.player.on(bitmovin.player.PlayerEvent.Playing, () => {
        console.log('player is playing', this.$store.getters.user)
        if (this.fromTimestamp) {
          this.fromTimestamp = false
          db.collection('users_videos_last_times')
            .doc(this.$store.getters.user.uid)
            .collection('videos')
            .doc(this.modalData.slug)
            .get().then((doc) => {
              var data = doc.data()
              console.log('{timestamp}', data)
              if (data && data.timestamp) {
                this.player.seek(data.timestamp)
              }
            })
        }
      })

      this.player.on(bitmovin.player.PlayerEvent.Destroy, () => {
        console.log('player destroyed')
        const duration = (new Date().getTime()) - this.session.date
        this.sessionRef.update({ duration: duration })
      })

    }
  },
  watch: {
    program () {
      this.modalData && this.setup()
    }
  },
  beforeDestroy () {
      console.log('player destroy', this. player)

    if (this.player) {
      console.log('player destroy')
      const allTime = this.player.getDuration()
      var current = this.player.getCurrentTime()
      if ((allTime - current) <= 30) {
        // current = 0
      }

      console.log(this.modalData.id, {allTime, current})

      db.collection('users_videos_last_times')
        .doc(this.$store.getters.user.uid)
        .collection('videos')
        .doc(this.modalData.slug).set({
          id: this.modalData.id,
          timestamp: current,
          duration: allTime,
          progress: 100 * (current || 0) / (allTime || 1)
        })

      this.player.destroy()
      // const duration = (new Date().getTime()) - this.session.date
      // this.sessionRef.update({duration: duration})
    }
  }
}
</script>
<style scoped>

.wrapper {
  height: 93vh;
}
.player {
  max-width: 900px;
  width: 90%;
  margin: auto;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.75);
}
</style>
<style>
/*.bmpui-ui-playbacktoggle-overlay {
  opacity: 0;
}
.bmpui-player-state-playing .bmpui-ui-playbacktoggle-overlay {
  opacity: 0 !important;
}
.bmpui-controls-hidden .bmpui-ui-playbacktoggle-overlay {
  opacity: 0 !important;
}
.bmpui-controls-shown .bmpui-ui-playbacktoggle-overlay {
  opacity: 1 !important;
}*/
.bmpui-ui-watermark {
  display: none;
}
</style>